/*
*****************************************************************************
*File :role.js
*Module : Dashboard Frontend
*Purpose :Defining the roles
*Author : UI Team
*Copyright : Copyright 2021, Lab to Market Innovations Private Limited
*****************************************************************************
*/

export const Role = {
    Admin: 'Admin',
    User: 'Train Driver'
}
